import gql from 'graphql-tag';

export default gql`
  mutation deleteAccessRule($channelId: UUID!, $accessRuleId: UUID!) {
    deleteAccessRule(channelId: $channelId, accessRuleId: $accessRuleId)
  }
`;
